import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Drawer } from 'vaul';
import { useLeafletMap } from '../leaflet-map/MapContext';
import { Z_INDEX } from '../../constants/zIndex';
import { selectDrawerSnapPoint } from '../../store/app/app.selector';
import { setDrawerSnapPoint } from '../../store/app/app.slice';
import { MAX_SNAP, MIN_SNAP } from '../../constants/drawerSnapPoint';

interface Props {
    children?: React.ReactNode;
    topBlockChildren?: React.ReactNode;
    keepMounted?: boolean;
    isOpenDefault?: boolean;
    hideBackdrop?: boolean;
    drawerBleeding?: number;
    closedHeight?: number;
    dismisable?: boolean;
    onClose?: () => void;
}

export default function SwipeableEdgeDrawer(props: Props) {
    const { children, dismisable = false, onClose } = props;
    const { disableMapInteraction, enableMapInteraction } = useLeafletMap();
    const dispatch = useDispatch();
    const snap = useSelector(selectDrawerSnapPoint);

    const handleSnapChange = (snapPoint: number | string | null) => {
        dispatch(setDrawerSnapPoint(snapPoint));
    };

    return (
        <Drawer.Root
            repositionInputs={false}
            defaultOpen
            snapPoints={[MIN_SNAP, MAX_SNAP]}
            activeSnapPoint={snap}
            setActiveSnapPoint={handleSnapChange}
            modal={false}
            dismissible={dismisable}
            onOpenChange={open => {
                if (!open && onClose) {
                    onClose();
                }
            }}
            noBodyStyles>
            <Drawer.Overlay
                style={{
                    position: 'fixed',
                    inset: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.4)',
                    zIndex: Z_INDEX.MAP_OVERLAY,
                    display: snap === 1 ? 'block' : 'none',
                }}
            />
            <Drawer.Content
                style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: '100%',
                    backgroundColor: '#fff',
                    borderTopLeftRadius: 8,
                    borderTopRightRadius: 8,
                    zIndex: Z_INDEX.MAP_DRAWER,
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: 'calc(100% - 80px)',
                    touchAction: 'none',
                    outline: 'none',
                }}
                onTouchStart={disableMapInteraction}
                onTouchEnd={enableMapInteraction}>
                <Drawer.Handle
                    style={{
                        width: 32,
                        height: 2,
                        backgroundColor: '#000000',
                        borderRadius: 5,
                        margin: '10px auto',
                        outline: 'none',
                    }}
                />
                {children}
            </Drawer.Content>
        </Drawer.Root>
    );
}
